module.exports = __webpack_public_path__ + "static/media/personal-info.5e91ebbc.svg";